import React from 'react';
import { Box, Card, CardContent, SxProps, Theme, Typography } from '@mui/material';

/**
 * Card de sección del home de la orden: mismo lenguaje visual que el strip de
 * facturación (borde sutil, radio 2, sombra suave, título con ícono y acción).
 */

interface SectionCardProps {
	title: string;
	icon?: React.ReactNode;
	/** Acción alineada a la derecha del título (botón, link, menú). */
	action?: React.ReactNode;
	children: React.ReactNode;
	sx?: SxProps<Theme>;
	contentSx?: SxProps<Theme>;
}

const baseCardSx = {
	border: '1px solid rgba(0,0,0,0.08)',
	borderRadius: 2,
	boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
};

export const SectionCard = ({ title, icon, action, children, sx, contentSx }: SectionCardProps): JSX.Element => (
	<Card elevation={0} sx={[baseCardSx, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
		<CardContent
			sx={[
				{ display: 'flex', flexDirection: 'column', flex: 1, gap: 1 },
				...(Array.isArray(contentSx) ? contentSx : contentSx ? [contentSx] : []),
			]}
		>
			<Box display="flex" alignItems="center" gap={1} mb={0.5}>
				{icon && <Box sx={{ display: 'flex', alignItems: 'center', color: 'text.secondary' }}>{icon}</Box>}
				<Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
					{title}
				</Typography>
				<Box sx={{ flex: 1 }} />
				{action}
			</Box>
			{children}
		</CardContent>
	</Card>
);

export default SectionCard;
